import { render, staticRenderFns } from "./CreateOrUpdate.vue?vue&type=template&id=25ba659e&"
import script from "./CreateOrUpdate.vue?vue&type=script&lang=ts&"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports